import { HeaderNavEndpoint, HeaderNavEndpointRoutes } from './shell.interface';

export class ShellEndpointFactory
{
	public static build(baseUrl: string): HeaderNavEndpoint
	{
		return {
			baseUrl: baseUrl,
			routes: this.buildRoutes(baseUrl)
		};
	}
	private static buildRoutes(baseUrl: string): HeaderNavEndpointRoutes
	{
		return {
			headerendpoints: {
				toString: () => `${baseUrl}v0/api`,
				aemheaders: {
					toString: () => `${baseUrl}v0/cms/headers`
				},
				aembusinessaccountheader: {
					toString: () => `${baseUrl}v0/v1/aem-business-account`
				},
				cmsbusinessaccountheaderraymond: {
					toString: () => `${baseUrl}v0/v1/cms-business-account`
				}
			}
		} as HeaderNavEndpointRoutes;
	}
}
